import { useEffect, useState } from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { AuthenticationContainer } from '../AuthenticationContainer';
import { ModalFailed } from 'shared/components/ModalFailed';
import { ModalFormContainer } from '../ModalFormContainer';
import { selectModalVisible } from 'shared/selectors/modal';
import { selectHaveActiveDailyRents } from 'shared/selectors/haveActiveDailyRents';
import { selectLead } from 'shared/selectors/lead';
import { useAppDispatch } from 'shared/hooks';
import { setVisible } from 'shared/slices';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { NBSP } from 'shared/constants/symbols';

export const ModalContainer: React.FC = () => {
  const [isMounted, setIsMounted] = useState(false);

  const {
    custom: { cianUserId },
  } = useApplicationContext();

  const visible = useSelector(selectModalVisible);
  const haveActiveDailyRents = useSelector(selectHaveActiveDailyRents);
  const lead = useSelector(selectLead);

  const dispatch = useAppDispatch();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleModalVisible = () => {
    dispatch(setVisible(false));
  };

  const renderContent = () => {
    if (!cianUserId) {
      return <AuthenticationContainer />;
    }

    if (lead.exists === true) {
      return (
        <ModalFailed
          image="lead-sended"
          title="Вы уже отправили заявку"
          description="Бонусы начислены в ваш личный кабинет, проверить можно в разделе «Операции»"
        />
      );
    }

    if (haveActiveDailyRents?.value === true) {
      return (
        <ModalFailed
          image="cant-apply"
          title={`У вас уже есть опубликованные объекты на${NBSP}Циан${NBSP}Посуточно`}
          description="Не сможем начислить вам бонус"
        />
      );
    }

    return <ModalFormContainer />;
  };

  if (!isMounted) {
    return null;
  }

  return <ModalWindow onClose={handleModalVisible} open={visible} content={renderContent()} />;
};
